import React from "react";

import * as Icons from "/component/base/Icon";
import theme from "/theme/default";

import { InfoBannerContainer, InfoBannerInnerContainer, InfoBannerLink } from "./InfoBanner.styles";
import { Props } from "./InfoBanner.types";

const InfoBanner = ({
  children,
  variant = "default",
  link,
  linkColor = theme.colors.brandActionBlue,
  linkText,
  icon = <Icons.Info />,
  showIcon,
  enabled,
  ...props
}: Props) => {
  if (!enabled) return null;

  return (
    <InfoBannerContainer variant={variant} {...props}>
      {showIcon && <div>{icon}</div>}
      <InfoBannerInnerContainer>
        {children}
        {link && linkText && (
          <InfoBannerLink target="_blank" color={linkColor} href={link}>
            {linkText}
          </InfoBannerLink>
        )}
      </InfoBannerInnerContainer>
    </InfoBannerContainer>
  );
};

export default InfoBanner;
